const extractFirstMessage = (value) => {
  if (value == null) return null;

  if (Array.isArray(value)) {
    return (
      value
        .map((item) => extractFirstMessage(item))
        .filter(Boolean)
        .join(' ')
        .trim() || null
    );
  }

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object') {
    if ('detail' in value) return extractFirstMessage(value.detail);
    if ('error' in value) return extractFirstMessage(value.error);
    if ('message' in value) return extractFirstMessage(value.message);

    const [firstKey] = Object.keys(value);
    if (!firstKey) return null;

    const formattedKey = firstKey.charAt(0).toUpperCase() + firstKey.slice(1);
    const nestedMessage = extractFirstMessage(value[firstKey]);

    return nestedMessage ? `${formattedKey}: ${nestedMessage}` : formattedKey;
  }

  return String(value);
};

export const extractApiMessage = (source, fallback = null) => {
  const payload = source?.response?.data ?? source?.data ?? source;
  const message = extractFirstMessage(payload) ?? extractFirstMessage(source?.message);

  return message || fallback;
};

export const extractApiStatus = (source) => source?.response?.status ?? source?.status ?? null;
